import { useTranslation } from 'react-i18next'

import { ListRequestParams } from 'modules/domain/types'
import { CarrierRole } from '../../types'
import { ASelectFilter } from 'views/components/Analytics'
import { FC } from 'react'

type Props = {
  listRequestParams: ListRequestParams
  updateFilterState: (filterObj: Record<string, string>) => void
}

export const CarrierRoleFilter: FC<Props> = ({ listRequestParams, updateFilterState }) => {
  const { t } = useTranslation('logisticsKR')

  const options = Object.keys(CarrierRole).map((key) => ({
    value: key,
    label: t(`carrierRoles.${key}`),
  }))

  return (
    <ASelectFilter
      id="carrierRole"
      placeholder={t('carrierRole')}
      options={options}
      value={listRequestParams.filter.carrier_role}
      onChange={(carrier_role) => updateFilterState({ carrier_role })}
      showSearch={false}
    />
  )
}
